"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var base_service_1 = require("../base-service");
var alertminer_api_configuration_1 = require("../alertminer-api-configuration");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../alertminer-api-configuration"));
var i2 = __importStar(require("@angular/common/http"));
var ChangeLogClientService = /** @class */ (function (_super) {
    __extends(ChangeLogClientService, _super);
    function ChangeLogClientService(config, http) {
        return _super.call(this, config, http) || this;
    }
    /**
     * @param entityId undefined
     */
    ChangeLogClientService.prototype.ByEntityidGETResponse = function (entityId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/ChangeLog/" + entityId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param entityId undefined
     */
    ChangeLogClientService.prototype.ByEntityidGET = function (entityId) {
        return this.ByEntityidGETResponse(entityId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `ChangeLogClientService.AddTermChangeLogByVehicleidByTermPOSTParams` containing the following parameters:
     *
     * - `vehicleId`:
     *
     * - `term`:
     */
    ChangeLogClientService.prototype.AddTermChangeLogByVehicleidByTermPOSTResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('POST', this.rootUrl + ("/api/ChangeLog/Term/" + params.vehicleId + "/" + params.term), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `ChangeLogClientService.AddTermChangeLogByVehicleidByTermPOSTParams` containing the following parameters:
     *
     * - `vehicleId`:
     *
     * - `term`:
     */
    ChangeLogClientService.prototype.AddTermChangeLogByVehicleidByTermPOST = function (params) {
        return this.AddTermChangeLogByVehicleidByTermPOSTResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `ChangeLogClientService.AddPriceChangeLogByVehicleidByPricePOSTParams` containing the following parameters:
     *
     * - `vehicleId`:
     *
     * - `price`:
     */
    ChangeLogClientService.prototype.AddPriceChangeLogByVehicleidByPricePOSTResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('POST', this.rootUrl + ("/api/ChangeLog/Price/" + params.vehicleId + "/" + params.price), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `ChangeLogClientService.AddPriceChangeLogByVehicleidByPricePOSTParams` containing the following parameters:
     *
     * - `vehicleId`:
     *
     * - `price`:
     */
    ChangeLogClientService.prototype.AddPriceChangeLogByVehicleidByPricePOST = function (params) {
        return this.AddPriceChangeLogByVehicleidByPricePOSTResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    ChangeLogClientService.ByEntityidGETPath = '/api/ChangeLog/{entityId}';
    ChangeLogClientService.AddTermChangeLogByVehicleidByTermPOSTPath = '/api/ChangeLog/Term/{vehicleId}/{term}';
    ChangeLogClientService.AddPriceChangeLogByVehicleidByPricePOSTPath = '/api/ChangeLog/Price/{vehicleId}/{price}';
    ChangeLogClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ChangeLogClientService_Factory() { return new ChangeLogClientService(i0.ɵɵinject(i1.AlertminerApiConfiguration), i0.ɵɵinject(i2.HttpClient)); }, token: ChangeLogClientService, providedIn: "root" });
    return ChangeLogClientService;
}(base_service_1.BaseService));
exports.ChangeLogClientService = ChangeLogClientService;
